export default class TextImgList {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {}
}
